function accordion() {
  const toggles = document.querySelectorAll('.accordion-toggle')
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', function () {
      const submenu = this.querySelector('ul')

      const isOpen = submenu.style.height && submenu.style.height !== '0px'

      if (isOpen) {
        submenu.style.height = '0px'
        toggle.classList.remove('open')
      } else {
        // Close others if you want one-at-a-time behavior
        // document.querySelectorAll(".submenu").forEach((sm) => sm.classList.remove("open"));
        submenu.style.height = 'auto'
        const fullHeight = `${submenu.scrollHeight}px`
        submenu.style.height = '0px' // reset first to trigger animation
        // Then animate to actual height
        requestAnimationFrame(() => {
          submenu.style.height = fullHeight
        })

        toggle.classList.add('open')
      }
    })
  })
}
export default accordion
